// extracted by mini-css-extract-plugin
export var arrowIcon = "ArrowIcon-module--arrow-icon--2GkLr";
export var arrowIconLight = "ArrowIcon-module--arrow-icon--light--17mHG";